module.exports = __webpack_public_path__ + "static/media/resume.a2ce342a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resume.svg
// module id = 114
// module chunks = 0